import React, { useContext } from 'react';
import {
  Typography,
  ListItemIcon,
  Divider,
  MenuList,
  MenuItem
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useSelector,useDispatch } from "react-redux";
import DashboardIcon from '@material-ui/icons/Dashboard';
import BlockIcon from '@material-ui/icons/Block';
import CarIcon from '@material-ui/icons/DirectionsCar';
import MapIcon from '@material-ui/icons/Map';
import ListIcon from '@material-ui/icons/ListAlt';
import ExitIcon from '@material-ui/icons/ExitToApp';
import OfferIcon from '@material-ui/icons/LocalOffer';
import PeopleIcon from '@material-ui/icons/People';
import MoneyIcon from '@material-ui/icons/AttachMoney';
import NotifyIcon from '@material-ui/icons/NotificationsActive';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import RateReviewIcon from '@material-ui/icons/RateReview';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import Forum from '@material-ui/icons/Forum';
import AmpStoriesIcon from '@material-ui/icons/AmpStories';
import Settings from '@material-ui/icons/Settings';
import { 
  languageJson,
  features
} from 'config';
import assets from 'assets';
import { FirebaseContext } from 'common';
import AppointmentBooking from "./appointment-booking";

function AppMenu() {
  const { api } = useContext(FirebaseContext);
  const languageCode = useSelector(state => state.languagedata.languageCode);
  const language = languageJson[languageCode];
  const {
    signOutUser
  } = api;
  const auth = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const LogOut = () => {
    dispatch(signOutUser());
  };

  let isAdmin = auth.info && auth?.info?.profile && auth?.info?.profile.usertype === 'admin';
  let isFleetAdmin = auth.info && auth?.info?.profile && auth?.info?.profile.usertype === 'fleetadmin';
  let isAccountant = auth.info && auth?.info?.profile && auth?.info?.profile.usertype === 'accountant';
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: '#00763F' }}>
        <img style={{ marginTop: '20px', marginBottom: '20px', width: '120px', height: '119px' }} src={assets.logo120x120} alt="Logo" />
      </div>
      <Divider />
      <MenuList>
         {isAdmin || isFleetAdmin ?
        <MenuItem component={Link} to="/dashboard-beta">
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.dashboard_text}</Typography>
        </MenuItem>
        :null}
         {isAdmin || isFleetAdmin ?
        <MenuItem component={Link} to="/saved-address">
          <ListItemIcon>
            <MapIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.saved_addresses}</Typography>
        </MenuItem>
        :null}
        {isAdmin || isFleetAdmin?
        <MenuItem component={Link} to="/bookingsadvance">
          <ListItemIcon>
            <ListIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.booking_history}</Typography>
        </MenuItem>
        :null}
        <MenuItem component={Link} to="/dispatchers-work-schedule">
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.dispatcher_work_schedule}</Typography>
        </MenuItem>
        {isAdmin  || isFleetAdmin ?
        <MenuItem component={Link} to="/incidentreports">
          <ListItemIcon>
            <ListIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.incident_reports}</Typography>
        </MenuItem>
        :null}
        {isAdmin || isFleetAdmin ?
            <MenuItem component={Link} to="/appointmentbooking">
                <ListItemIcon>
                    <ListIcon />
                </ListItemIcon>
                <Typography variant="inherit">{language.appointment_booking}</Typography>
            </MenuItem>
            : null}
        {isAdmin ?
        <MenuItem component={Link} to="/blockeddrivers">
          <ListItemIcon>
            <BlockIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.blocked_drivers}</Typography>
        </MenuItem>
        :null}
        {isAdmin ?
        <MenuItem component={Link} to="/blockedriders">
          <ListItemIcon>
            <BlockIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.blocked_riders}</Typography>
        </MenuItem>
        :null}
        {isAdmin || isFleetAdmin?
        <MenuItem component={Link} to="/guestusers">
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.guest_booking_history}</Typography>
        </MenuItem>
        :null}
        {isAdmin || isFleetAdmin?
        <MenuItem component={Link} to="/riders">
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.riders}</Typography>
        </MenuItem>
        :null}
        {isAdmin || isFleetAdmin?
        <MenuItem component={Link} to="/drivers">
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.drivers}</Typography>
        </MenuItem>
        :null}
        {isAdmin ?
        <MenuItem component={Link} to="/unapprove-drivers">
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.unapprove_drivers}</Typography>
        </MenuItem>
        :null}
        {isAdmin ?
        <MenuItem component={Link} to="drivers-work-schedule">
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.work_schedule}</Typography>
        </MenuItem>
        :null}
        {isAdmin?
        <MenuItem component={Link} to="/driversuspensions">
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.driver_suspensions}</Typography>
        </MenuItem>
        :null}
        {isAdmin || isFleetAdmin?
        <MenuItem component={Link} to="/chat">
          <ListItemIcon>
            <Forum />
          </ListItemIcon>
          <Typography variant="inherit">{language.chat}</Typography>
        </MenuItem>
        :null}
        {isAdmin?
        <MenuItem component={Link} to="/appsliders">
          <ListItemIcon>
            <AmpStoriesIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.app_slider}</Typography>
        </MenuItem>
        :null}
        {isAdmin ?
        <MenuItem component={Link} to="/defaultfeedbacks">
          <ListItemIcon>
            <RateReviewIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.default_feedbacks}</Typography>
        </MenuItem>
        :null}
        {isAdmin ?
        <MenuItem component={Link} to="/defaultchatmessages">
          <ListItemIcon>
            <RateReviewIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.default_chat_messages}</Typography>
        </MenuItem>
        :null}
        {isAdmin?
        <MenuItem component={Link} to="/fleetadmins">
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.fleetadmins}</Typography>
        </MenuItem>
        :null}
        {isAdmin ?
        <MenuItem component={Link} to="/cartypes">
          <ListItemIcon>
            <CarIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.car_type}</Typography>
        </MenuItem>
        :null}
        {isAdmin ?
        <MenuItem component={Link} to="/zones">
          <ListItemIcon>
            <MapIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.zone_text}</Typography>
        </MenuItem>
        :null}
        {isAdmin ?
        <MenuItem component={Link} to="/subzones">
          <ListItemIcon>
            <MapIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.subzones}</Typography>
        </MenuItem>
        :null}
        {isAdmin ?
        <MenuItem component={Link} to="/crowdedzones">
          <ListItemIcon>
            <MapIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.crowded_zones}</Typography>
        </MenuItem>
        :null}
        {isAdmin ?
        <MenuItem component={Link} to="/incrementhours">
          <ListItemIcon>
            <AccessTimeIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.increment_hours}</Typography>
        </MenuItem>
        :null}
        {isAdmin?
        <MenuItem component={Link} to="/cancelreasons">
          <ListItemIcon>
            <CarIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.cancellation_reasons}</Typography>
        </MenuItem>
        :null}
        {isAdmin?
        <MenuItem component={Link} to="/earningreports">
          <ListItemIcon>
            <MoneyIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.earning_reports}</Typography>
        </MenuItem>
        :null}
        {isAdmin?
        <MenuItem component={Link} to="/driverearning">
          <ListItemIcon>
            <MoneyIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.driver_earning}</Typography>
        </MenuItem>
        :null}
        {isAdmin || isAccountant?
        <MenuItem component={Link} to="/driverstaxes">
          <ListItemIcon>
            <MoneyIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.drivers_taxes_report}</Typography>
        </MenuItem>
        :null}
        {isAdmin?
        <MenuItem component={Link} to="/withdraws">
          <ListItemIcon>
            <MoneyIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.withdraws}</Typography>
        </MenuItem>
        :null}
        {isAdmin?
        <MenuItem component={Link} to="/tcupdatewallets">
          <ListItemIcon>
            <MoneyIcon />
          </ListItemIcon>
          <Typography variant="inherit">TC {language.add_to_wallet}</Typography>
        </MenuItem>
        :null}
        {isAdmin?
        <MenuItem component={Link} to="/addtowallet">
          <ListItemIcon>
            <MoneyIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.add_to_wallet}</Typography>
        </MenuItem>
        :null}
        {isAdmin || isFleetAdmin ?
        <MenuItem component={Link} to="/wallethistory">
          <ListItemIcon>
            <ListIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.wallet_history}</Typography>
        </MenuItem>
        :null}
        {/* {isAdmin?
        <MenuItem component={Link} to="/promos">
          <ListItemIcon>
            <OfferIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.promo}</Typography>
        </MenuItem>
        :null} */}
        {isAdmin?
        <MenuItem component={Link} to="/uservouchers">
          <ListItemIcon>
            <OfferIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.vouchers}</Typography>
        </MenuItem>
        :null}
        {isAdmin ?
        <MenuItem component={Link} to="/referralsettings">
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.referral_settings}</Typography>
        </MenuItem>
        :null}
        {isAdmin ?
        <MenuItem component={Link} to="/driverpromotions">
          <ListItemIcon>
            <OfferIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.driver_promotions}</Typography>
        </MenuItem>
        :null}
        {isAdmin?
            <MenuItem component={Link} to="/passengerdiscounts">
              <ListItemIcon>
                <OfferIcon />
              </ListItemIcon>
              <Typography variant="inherit">{language.passenger_discounts}</Typography>
            </MenuItem>
            :null}
        {isAdmin?
        <MenuItem component={Link} to="/notifications">
          <ListItemIcon>
            <NotifyIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.push_notification_title}</Typography>
        </MenuItem>
        :null}
        {isAdmin?
        <MenuItem component={Link} to="/termsandprivacy">
          <ListItemIcon>
            <Settings />
          </ListItemIcon>
          <Typography variant="inherit">{language.terms_and_privacy}</Typography>
        </MenuItem>
        :null}
        {isAdmin?
        <MenuItem component={Link} to="/settings">
          <ListItemIcon>
            <Settings />
          </ListItemIcon>
          <Typography variant="inherit">{language.settings_title}</Typography>
        </MenuItem>
        :null}
        {isAdmin?
        <MenuItem component={Link} to="/parameters">
          <ListItemIcon>
            <Settings />
          </ListItemIcon>
          <Typography variant="inherit">{language.parameters}</Typography>
        </MenuItem>
        :null}
        <MenuItem component={Link} to="/profile">
          <ListItemIcon>
            <PersonOutlineIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.profile}</Typography>
        </MenuItem>
        <MenuItem onClick={LogOut}>
          <ListItemIcon>
            <ExitIcon />
          </ListItemIcon>
          <Typography variant="inherit">{language.logout}</Typography>
        </MenuItem>
      </MenuList>
    </div>
  );
}

export default AppMenu;